import { apiUrl, customerHelpline, SPProviderName } from '@sp/config';
import { USER_ROLES } from '@sp/config/db_const';

export default {
  USER_ROLES,
  customerHelpline,
  SPProviderName,
  apiUrl,
};
